export default "__VITE_ASSET__B6NzpLJ5__"